export const EQUIPMENT_SURVEY_FIELD_UNIT_BY_KEY = {
    rooftopUnitSupplyAirRate: "cfm",
    airHandlingEquipmentSupplyAirRate: "cfm",
    centralPlantHeaterSize: "tons",
    centralPlantHeatPumpSize: "tons",
    centralPlantCoolerSize: "tons",
    terminalHeaterSize: "tons",
    terminalHeaterCoolerSize: "tons",
    terminalCoolerSize: "tons",
    heatPumpSize: "tons",
    domesticHotWaterHeaterSize: "tons",
    clothesDryersEnergyDensity: "kWh/m²",
    clothesWashersEnergyDensity: "kWh/m²",
    rooftopPhotovoltaicsSize: "kWDC",
    centralPlantGenericEquipmentSize: "tons",
} as const;
